import moment from 'moment-timezone';

function format(date: Date, format: string, timezone?: string): string {
  return moment.tz(date, timezone || "").format(format);
}

export default format;